import React from 'react';
import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import FormField from '@/shared/components/form/FormField';
import { BatchJobStorageEnum, BatchJobVCPUsEnum } from "Enums";
import renderSelectField from '@/shared/components/form/Select';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import { Card, CardBody, CardTitleWrap, CardTitle, CardSubhead } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const validate = (values) => {
    const errors = {};
    if (values.tiles_directory_uri && !values.tiles_directory_uri.startsWith('s3://'))
        errors.tiles_directory_uri = 'Invalid S3 directory address';

    return errors;
};

const required = value => (value !== undefined ? undefined : 'Required')

const EditCreateAssetRequest = (props) => {
    
    const sendCreateCOGAssetRequest = (values) => {
        let createCOGAsset = { ...values };
        createCOGAsset.mission_id = props.request.mission_id;
        createCOGAsset.batch_job_vcpus = createCOGAsset.batch_job_vcpus.value;
        createCOGAsset.batch_job_storage = createCOGAsset.batch_job_storage.value;
        createCOGAsset.rotate_by_orientation = createCOGAsset.rotate_by_orientation;

        Swal.fire({
            title: 'Warning!',
            text: `This will edit a create asset request. Are you sure you want to continue?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                AdminInterface.instance.editCreateAssetRequest(createCOGAsset.id, createCOGAsset).then(() => {
                    withReactContent(Swal).fire({
                        icon: 'success',
                        title: 'Success',
                        text: `Create asset request editted!`,
                    });
                }).catch((error) => {
                    withReactContent(Swal).fire({
                        icon: 'error',
                        title: 'Error',
                        html: error.response.data?.detail,
                    });
                })
            }
        });
    }

    const submitNewRequest = (values) => {
        sendCreateCOGAssetRequest(values)
    };

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Edit Create Asset Request</CardTitle>
                        <CardSubhead>This form edits a create asset request.</CardSubhead>
                    </CardTitleWrap>
                    {props.request && <Form onSubmit={submitNewRequest} validate={validate} initialValues={{
                        id: props.request.id,
                        batch_job_vcpus: { 
                            value: props.request.batch_job_vcpus, 
                            label: Object.keys(BatchJobVCPUsEnum).find(key => BatchJobVCPUsEnum[key] === props.request.batch_job_vcpus) || ''
                        },
                        batch_job_storage: { 
                            value: props.request.batch_job_storage, 
                            label: Object.keys(BatchJobStorageEnum).find(key => BatchJobStorageEnum[key] === props.request.batch_job_storage) || '' },
                        tiles_directory_uri: props.request.tiles_directory_uri,
                        hosting_bucket: props.request.hosting_bucket,
                        source_srs: props.request.source_srs,
                        rotate_by_orientation: props.request.rotate_by_orientation,
                        footprint_shapefile_uri: props.request.footprint_shapefile_uri,
                    }} >
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit}>
                                <FormGroup>
                                    <FormGroupLabel>Request ID</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="id" component={FormField} disabled ></Field>
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Virtual CPUs</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="batch_job_vcpus" component={renderSelectField} validate={required}
                                            options={Object.entries(BatchJobVCPUsEnum).map(([label, value]) => ({ value, label }))} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Storage</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="batch_job_storage" component={renderSelectField} validate={required}
                                            options={Object.entries(BatchJobStorageEnum).map(([label, value]) => ({ value, label }))} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Footprint Shapefile URI (*.Shp/*.geojson/*.json file)</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="footprint_shapefile_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/Footprint.zip" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Images Require Rotation by Direction</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name='rotate_by_orientation' type="checkbox" component={renderCheckBoxField} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Hosting Bucket</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="hosting_bucket" component={FormField} placeholder="For example: fm-tms"/>
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Source SRS</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="source_srs" component={FormField} type="number" placeholder="For example: 4326" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                </FormButtonToolbar>
                            </FormContainer>
                        )}
                    </Form>}
                </CardBody>
            </Card>
        </Col>
    );
};

export default EditCreateAssetRequest;